import React, { useCallback } from 'react';
import { FormattedMessage } from 'react-intl';
import { Drawer } from 'ui-components/components/drawer/drawer';
import { DrawerHeader } from 'ui-components/components/drawer/drawer-header';
import { NewShopperOptions } from '../rate-shopper-page/new-shopper-options';
import { EditShopperDrawer } from '../edit-shopper-drawer';
import { useRateShopperContext } from '../../context/rate-shopper-context';
import { ACCESS_LEVELS, useRequiresRateShopperAccessLevel } from '../../../../../hooks/use-has-rate-shopper-access-level';
import { NO_OPTION_TYPE } from '../rate-shopper-page/new-shopper-options/constants';
import { CountryConfigNames } from '../../../../../contexts/country-config-context/country-config-enums';
import { useCountryConfig } from '../../../../../hooks/use-country-config';
import messages from '../rate-shopper-page/messages';
import style from './style.module.less';

/**
 * @typedef {import('../../../../../prop-types/rate-shopper').RateShopper} RateShopper
 * @param {object} props
 * @param {RateShopper} props.shopper
 * @param {boolean} props.isReadOnly
 * @param {() => void} props.onClose
 * @returns {JSX.Element}
 */
export const RateShopperDrawer = ({ onClose, shopper, isReadOnly = false }) => {
  const hasPremiumAccess = useRequiresRateShopperAccessLevel(ACCESS_LEVELS.PREMIUM);
  const { templateOptionType, setTemplateOptionType } = useRateShopperContext();
  const [showTemplateOptionCards] = useCountryConfig(CountryConfigNames.ShowTemplateOptionCards);
  const showOptionScreen = hasPremiumAccess && templateOptionType === NO_OPTION_TYPE && showTemplateOptionCards;

  const drawerTitle = showOptionScreen ? (
    <FormattedMessage {...messages.newShopperDrawerHeaderText} />
  ) : (
    <FormattedMessage {...messages.editShopperDrawerHeaderText} />
  );

  const closeDrawer = useCallback(() => {
    setTemplateOptionType(NO_OPTION_TYPE);
    onClose();
  }, [onClose, setTemplateOptionType]);

  return (
    <Drawer canvasClassName={style['edit-shopper-canvas']} onCancel={closeDrawer} onClose={closeDrawer}>
      <DrawerHeader
        closeButtonAriaLabel={messages.closeEditShopperButtonAriaLabel}
        title={drawerTitle}
        titleClassName={style['drawer-header-title']}
      />
      {showOptionScreen && <NewShopperOptions onClose={closeDrawer} />}

      {!showOptionScreen && <EditShopperDrawer isReadonly={isReadOnly} onClose={closeDrawer} shopper={shopper} />}
    </Drawer>
  );
};
